const accordionItems = [
  {
    key: "1",
    label: "What is the STRM Assessment?",
    children:
      "The STRM Assessment is a comprehensive diagnostic tool that evaluates your music career across multiple dimensions, including audience engagement, social media presence, streaming performance, and industry positioning.",
  },
  {
    key: "2",
    label: "How long does the Assessment take to complete?",
    children:
      "The Assessment typically takes between 15 and 30 minutes to complete. We recommend setting aside uninterrupted time so you can answer each question thoughtfully and accurately.",
  },
  {
    key: "3",
    label: "What do I receive after completing the Assessment?",
    children:
      "After completing the Assessment, you receive a detailed report with personalized insights, a career stage evaluation, and actionable recommendations tailored to your current position in the music industry.",
  },
  {
    key: "4",
    label: "How are credits used?",
    children:
      "Each credit allows you to run one Assessment for yourself. Invite credits can be used to have a collaborator, manager, or investor answer the Assessment about you, providing an external perspective on your career.",
  },
  {
    key: "5",
    label: "Can I retake the Assessment?",
    children:
      "Yes. We recommend retaking the Assessment every 3 to 6 months to track your progress. Each new Assessment consumes one credit and generates a fresh report reflecting your current state.",
  },
  {
    key: "6",
    label: "What is an invite credit?",
    children:
      "An invite credit allows you to send a link to someone in your network — such as a manager, investor, or collaborator — so they can fill out the Assessment from their perspective. This external view enriches your report with additional insights.",
  },
  {
    key: "7",
    label: "How do I interpret my Assessment results?",
    children:
      "Your results are presented in an easy-to-read report with scores per category, a career stage classification, and prioritized recommendations. You can also watch our tutorial video above to learn how to make the most of your report.",
  },
  {
    key: "8",
    label: "Is my Assessment data private?",
    children:
      "Yes. Your Assessment responses and results are strictly confidential and are only accessible to you and any collaborators you explicitly invite. STRM does not share your individual data with third parties.",
  },
  {
    key: "9",
    label: "What happens if I lose my credits?",
    children:
      "Credits have an expiration date shown on your dashboard. Make sure to use them before they expire. If your credits expire, you can purchase new ones at any time through the checkout page.",
  },
  {
    key: "10",
    label: "How do I purchase more credits?",
    children:
      'You can purchase additional credits by clicking the "Buy" button on this page. Our plans offer individual credits as well as packs with bonus invite credits for teams and collaborators.',
  },
];

export default accordionItems;
